import fdaLogo from '@/assets/fda.png';
import { Button } from '@/components/ui/button';
import { FlexCol, FlexRow } from '@/components/ui/flex';
import { Text } from '@/components/ui/text';
import { Database, ExternalLink, FileText } from 'lucide-react';
import { type FC } from 'react';
import { type Source } from './ChatContext';

export const SourceComponent: FC<{
  source: Source;
  citationNumber: number;
  onSourceClick?: () => void;
}> = ({ source, onSourceClick }) => {
  if (source.type === 'file') {
    const isFdaSource =
      source?.groupUname &&
      ['fda-guidance-radio', 'fdaguidance', 'fda21cfr'].includes(
        source?.groupUname
      );

    return (
      <FlexCol
        className="gap-2 w-full cursor-pointer hover:bg-neutral-50 p-4 rounded-xl"
        onClick={onSourceClick}
      >
        <FlexRow className="items-center gap-2">
          {isFdaSource && (
            <img src={fdaLogo} alt="FDA Logo" className="w-8 opacity-50" />
          )}
          <FlexRow
            className="gap-1.5 py-1 px-2 rounded-lg border border-neutral-200"
            justifyContent="center"
            alignItems="center"
          >
            <FileText className="w-4 h-4 text-neutral-900" />
            <Text
              variant="body-sm"
              className="font-medium text-neutral-900 tracking-[0.07px]"
              style={{ fontFamily: 'inherit' }}
            >
              Document
            </Text>
          </FlexRow>
        </FlexRow>

        {
          <Text
            variant="body-sm"
            className="font-semibold text-neutral-900 tracking-[0.07px] hover:no-underline"
            style={{ fontFamily: 'inherit' }}
          >
            {source.fileName?.replace(/\.[^/.]+$/, '')}
          </Text>
        }

        {/* Page info */}
        <Text
          variant="body-sm"
          className="font-medium text-neutral-600 tracking-[0.07px]"
          style={{ fontFamily: 'inherit' }}
        >
          Page {source.pageNumber}
        </Text>
      </FlexCol>
    );
  }

  if (source.type === 'database') {
    const isFdaSource = [
      'fda510kSubmissionDbSearch',
      'fdaDeviceClassificationDbSearch',
      'fdaAdverseEventsSearch',
    ].includes(source.toolName);
    return (
      <FlexRow className="items-center justify-between gap-2 p-4 rounded-xl">
        <FlexCol className="gap-2 w-full">
          <FlexRow className="items-center gap-2">
            {isFdaSource && (
              <img src={fdaLogo} alt="FDA Logo" className="w-8 opacity-50" />
            )}
            <FlexRow
              className="gap-1.5 py-1 px-2 rounded-lg border border-neutral-200"
              justifyContent="center"
              alignItems="center"
            >
              <Database className="w-4 h-4 text-neutral-900" />
              <Text
                variant="body-sm"
                className="font-medium text-neutral-900 tracking-[0.07px]"
                style={{ fontFamily: 'inherit' }}
              >
                Database
              </Text>
            </FlexRow>
          </FlexRow>

          <Text
            variant="body-sm"
            className="font-semibold text-neutral-900 tracking-[0.07px] hover:no-underline"
            style={{ fontFamily: 'inherit' }}
          >
            {source.databaseName}
          </Text>
        </FlexCol>
        <Button variant="outline" size="sm" onClick={onSourceClick}>
          <ExternalLink className="w-4 h-4 text-neutral-700" />
        </Button>
      </FlexRow>
    );
  }
};
